import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Import our custom theme
import { havenTheme } from './theme/theme';

// Import components
import Layout from './components/layout/Layout';
import HomePage from './pages/home/HomePage';
import HomeownerStartPage from './pages/home/HomeownerStartPage';
import { HomeownerStorePage } from './pages/homeowner-store';
import OrderConfirmationPage from './pages/OrderConfirmationPage';

import ResidentialVentilationPage from './pages/solutions/ResidentialVentilationPage';
import ActiveAirManagementPage from './pages/solutions/ActiveAirManagementPage';
import RadonMitigationPage from './pages/solutions/RadonMitigationPage';
import ResourcesPage from './pages/resources/ResourcesPage';
import AboutPage from './pages/about/AboutPage';
import ContactPage from './pages/contact/ContactPage';
import BecomeProPage from './pages/pro/BecomeProPage';
import HavenIaqStartPage from './pages/HavenIaqStartPage';
import EmailTestPage from './pages/EmailTestPage';

// Import blog posts
import NoOneCaresPost from './pages/blog/NoOneCares';
import TrickleStarPost from './pages/blog/TrickleStar';
import { BlogPage, BlogPostPage } from './pages/blog';

// Create a client for React Query
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={havenTheme}>
        <CssBaseline />
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/homeowner-start" element={<HomeownerStartPage />} />
              <Route path="/homeowner-store" element={<HomeownerStorePage />} />
              <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
              <Route path="/email-test" element={<EmailTestPage />} />

              <Route path="/residential-demand-control-ventilation-for-humid-climates" element={<ResidentialVentilationPage />} />
              <Route path="/residential-demand-control-ventilation" element={<ResidentialVentilationPage />} />
              <Route path="/active-air-management" element={<ActiveAirManagementPage />} />
              <Route path="/haven-products" element={<ActiveAirManagementPage />} />
              <Route path="/smart-home-radon-mitigation" element={<RadonMitigationPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/become-a-pro" element={<BecomeProPage />} />
              <Route path="/haven-iaq-start" element={<HavenIaqStartPage />} />
              
              {/* Blog routes */}
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              
              {/* Static blog post routes (for backwards compatibility) */}
              <Route path="/blog/no-one-cares-about-residential-controls" element={<NoOneCaresPost />} />
              <Route path="/blog/haven-meets-tricklestar" element={<TrickleStarPost />} />
            </Routes>
          </Layout>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
